// extracted by mini-css-extract-plugin
export default {"wrap":"index-module__wrap--2_A2U","captchaPlaceholder":"index-module__captchaPlaceholder--20mGl"};